import axios from 'axios';

export default {
  async requestImageRecognition(projectId: string, modelId: string, imgData: string, token: string): Promise<any> {
    try {
    const res = await axios({
      method: 'post',
      url: `https://automl.googleapis.com/v1/projects/${projectId}/locations/us-central1/models/${modelId}:predict`,
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/javascript; text",
      },
      data: {
        'payload': {
          "image": {
            "imageBytes": imgData
          }
        }
      }
    });
    return res.data;
  } catch (error) {
    // Error 😨
    if (error.response) {
        /*
         * The request was made and the server responded with a
         * status code that falls out of the range of 2xx
         */
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        return error.response
    } else if (error.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser and an instance
         * of http.ClientRequest in Node.js
         */
        console.log(error.request);
        return error.request
    } else {
        // Something happened in setting up the request and triggered an Error
        console.log('Error', error.message);
    }
    console.log(error);
    return error
}
  },
}